var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { localeConfig } from 'shared/domains/languages';
import { getAllMarketCodes } from 'shared/domains/markets/config';
import { TemplateBrowserComposersDocument } from './query.gql';
export const useTemplates = () => {
    const marketCodes = getAllMarketCodes();
    const _a = useQuery(TemplateBrowserComposersDocument, {
        variables: { marketCodes },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { composers = [] } = data || {};
    const flattenedTemplates = composers.flatMap((composer) => {
        const { templates } = composer;
        if (!templates) {
            return [];
        }
        const [metadata] = composer.metadata || [];
        return templates.map((template) => ({
            id: template.id,
            name: metadata.name,
            composerId: composer.id,
            locale: {
                code: template.marketLocaleCode,
                name: localeConfig.getLocale({ languageCode: template.marketLocaleCode }).getName(),
            },
        }));
    });
    const sortedTemplates = flattenedTemplates.sort((a, b) => a.name.localeCompare(b.name));
    return Object.assign(Object.assign({}, rest), { templates: sortedTemplates });
};
